import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import { formatCurrencyAsText } from '~/utils/functions';
import { InputMoney, InputSelect } from '~/components/NovosInputs';
import { useDevolucaoSaidaNFEForn } from '~/pages/DevolucaoESaidaNFDeFornecedor/DevolucaoSaidaNFEFornContext';
import { SelectType } from '~/pages/DevolucaoESaidaNFDeFornecedor/protocols';
import api from '~/services/api';

export const FormFinanceiro: React.FC = () => {
  const [total, setTotal] = useState(0);
  const [categorias, setCategorias] = useState<SelectType[]>([]);
  const [contas, setContas] = useState<SelectType[]>([]);

  const {
    register,
    parcelasFinanceiro,
    isUpdate,
    watch,
    codLoja,
    formFinanceiro: {
      setValue,
      clearErrors,
      control,
      formState: formStateFinanceiro,
    },
  } = useDevolucaoSaidaNFEForn();

  const perfil = watch('cod_perfil');

  useEffect(() => {
    let totalParcelas = 0;
    parcelasFinanceiro.map((parcela) => {
      totalParcelas += parcela.val_parcela || 0;
      return parcela;
    });
    setTotal(totalParcelas);
  }, [parcelasFinanceiro]);

  // Categorias
  useEffect(() => {
    (async () => {
      if (perfil) {
        const tipo_categoria = perfil.tipo_operacao === 1 ? 0 : 1;
        const { data } = await api.get(
          `/perfil-loja/categorias/${tipo_categoria}`,
        );
        const option = data.data.map((categoria: any) => {
          return {
            value: categoria.cod_categoria,
            label: categoria.descricao,
            ...categoria,
          };
        });

        setCategorias(option);
      }
    })();
  }, [perfil]);

  // Contas
  useEffect(() => {
    (async () => {
      if (codLoja) {
        const { data } = await api.get(`/contas/loja/${codLoja}`);
        const option = data.data.map((conta: any) => {
          return {
            value: conta.cod_cc,
            label: conta.descricao,
            ...conta,
          };
        });

        setContas(option);
      }
    })();
  }, [codLoja]);

  return (
    <>
      <Row className="d-flex align-items-end">
        <Col sm={12} md={2}>
          <InputSelect
            ListaWidth="580px"
            label="Categoria"
            placeholder="Selecione..."
            name="categoria"
            register={register}
            isDisabled={isUpdate}
            isError={!!formStateFinanceiro.errors.categoria}
            control={control}
            options={categorias}
            changeSelected={(selected) => {
              clearErrors('categoria');
              setValue('categoria', selected);
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputSelect
            ListaWidth="480px"
            label="Conta"
            placeholder="Selecione..."
            name="conta"
            register={register}
            isDisabled={isUpdate}
            isError={!!formStateFinanceiro.errors.conta}
            control={control}
            options={contas}
            changeSelected={(selected) => {
              clearErrors('conta');
              setValue('conta', selected);
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputMoney
            label="Desconto"
            placeholder="0,00"
            min={0}
            decimals={2}
            name="val_desc_financeiro"
            disabled={isUpdate}
            register={register}
            isError={false}
            showIcon
          />
        </Col>
        <Col sm={12} md={2}>
          <InputMoney
            label="Encargos"
            placeholder="0,00"
            min={0}
            disabled={isUpdate}
            decimals={2}
            name="val_enc_financeiro"
            register={register}
            isError={false}
            showIcon
          />
        </Col>
        <Col sm={12} md={4}>
          <h5
            style={{
              textAlign: 'right',
              display: 'block',
              marginTop: '20px',
            }}
          >
            {`Total Financeiro: R$${formatCurrencyAsText(total)}`}
          </h5>
        </Col>
      </Row>
    </>
  );
};
